<template>
<div class="rq-root" :style="themePageStyle">
  <nav class="rq-topbar"><div class="container d-flex align-items-center justify-content-between py-2">
    <div class="d-flex align-items-center" style="gap:12px;">
      <back-button class="me-2" />
      <a href="javascript:void(0)" @click="$router.push('/dashboard')"><img src="/assets/images/flockr_logo.png" alt="Flockr" style="height:34px;" /></a>
      <span class="fw-semibold" style="color:var(--fm-h,#F5F0E8);font-size:15px;">Requisitions <span v-if="farm.name" style="opacity:.7;font-weight:400;">· {{ farm.name }}</span></span>
    </div>
    <button class="btn btn-sm btn-warning" @click="openCreate"><i class="mdi mdi-plus me-1"></i>New requisition</button>
  </div></nav>

  <div class="container rq-container">
    <div v-if="loading" class="text-center py-5"><div class="spinner-border text-warning"></div></div>

    <div v-else-if="!reqs.length" class="rq-card text-center" style="padding:40px;">
      <i class="mdi mdi-receipt-text-outline" style="font-size:48px;color:var(--fm-s,#6B6356);"></i>
      <div style="color:var(--fm-h,#F5F0E8);font-weight:600;margin-top:8px;">No requisitions yet</div>
      <div style="color:var(--fm-s,#6B6356);font-size:12px;margin-top:4px;">Create one for transport, fuel, staff costs or any farm expense that needs approval.</div>
      <button class="btn btn-warning mt-3" @click="openCreate"><i class="mdi mdi-plus me-1"></i>New requisition</button>
    </div>

    <div v-else>
      <div v-for="r in reqs" :key="'rq-'+r.id" class="rq-card mb-2">
        <div class="d-flex justify-content-between align-items-start flex-wrap" style="gap:8px;">
          <div class="flex-fill" style="min-width:0;">
            <div class="d-flex align-items-center gap-2 flex-wrap">
              <span class="rq-ref">{{ r.document_ref }}</span>
              <span class="rq-status" :class="'st-'+r.status">{{ statusLabel(r.status) }}</span>
            </div>
            <div style="color:var(--fm-h,#F5F0E8);font-weight:600;margin-top:4px;">{{ r.activity || r.project_code || 'Requisition' }}</div>
            <div style="color:var(--fm-s,#6B6356);font-size:12px;margin-top:2px;">
              <i class="mdi mdi-calendar me-1"></i>{{ fD(r.requisition_date) }}
              <span v-if="r.project_code"> · <i class="mdi mdi-folder-outline me-1"></i>{{ r.project_code }}</span>
              · <i class="mdi mdi-cash me-1"></i>KES {{ Number(r.total_kes||0).toLocaleString() }}
              <span v-if="r.prepared_by_name"> · By {{ r.prepared_by_name }}</span>
            </div>
            <div v-if="r.status==='rejected' && r.rejection_reason" style="color:#FF6B6B;font-size:11px;margin-top:4px;"><i class="mdi mdi-alert-outline me-1"></i>{{ r.rejection_reason }}</div>
          </div>
          <div class="d-flex gap-1 flex-wrap">
            <button class="btn btn-sm btn-warning" @click="openPrint(r)"><i class="mdi mdi-printer me-1"></i>View / Print</button>
            <button v-if="r.status==='draft' || r.status==='rejected'" class="btn btn-sm btn-outline-warning" @click="openEdit(r)"><i class="mdi mdi-pencil"></i></button>
            <button v-if="r.status==='draft'" class="btn btn-sm btn-outline-primary" @click="submit(r)"><i class="mdi mdi-send me-1"></i>Submit</button>
            <button v-if="r.status==='submitted' && canApprove" class="btn btn-sm btn-outline-success" @click="decide(r,'approved')"><i class="mdi mdi-check"></i></button>
            <button v-if="r.status==='submitted' && canApprove" class="btn btn-sm btn-outline-danger" @click="decide(r,'rejected')"><i class="mdi mdi-close"></i></button>
            <button v-if="r.status==='approved' && canApprove" class="btn btn-sm btn-outline-secondary" @click="decide(r,'paid')"><i class="mdi mdi-cash-check me-1"></i>Mark paid</button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Create / Edit modal -->
  <div v-if="showForm" class="rq-overlay" @click.self="showForm=false">
    <div class="rq-modal">
      <div class="d-flex justify-content-between align-items-start mb-3">
        <h5 class="m-0 fw-bold" style="color:var(--fm-h,#F5F0E8);"><i class="mdi mdi-receipt-text me-1"></i>{{ form.id ? 'Edit requisition' : 'New requisition' }}</h5>
        <button class="btn-close btn-close-white" @click="showForm=false"></button>
      </div>

      <div class="row g-2 mb-2">
        <div class="col-md-4"><label class="rq-label">Project / Reference</label><input v-model="form.projectCode" class="rq-input w-100" placeholder="e.g. REL, RANCH/005" /></div>
        <div class="col-md-5"><label class="rq-label">Activity *</label><input v-model="form.activity" class="rq-input w-100" placeholder="e.g. 17 BULLS TRANSPORT FROM REL TO CHOICE MEAT" /></div>
        <div class="col-md-3"><label class="rq-label">Date *</label><input v-model="form.requisitionDate" type="date" class="rq-input w-100" /></div>
      </div>

      <div class="d-flex justify-content-between align-items-center mt-3 mb-1">
        <h6 class="m-0 fw-bold" style="color:var(--fm-h,#F5F0E8);">Line items</h6>
        <button class="btn btn-sm btn-outline-warning" @click="addItem"><i class="mdi mdi-plus me-1"></i>Add line</button>
      </div>
      <div v-if="!form.items.length" class="rq-empty">No line items yet — click Add line.</div>
      <div v-else class="rq-items">
        <div class="rq-item rq-item-head">
          <div style="width:120px;">Date</div>
          <div class="flex-fill">Item / Description</div>
          <div style="width:140px;text-align:right;">Amount (KES)</div>
          <div style="width:32px;"></div>
        </div>
        <div v-for="(it, idx) in form.items" :key="'ri-'+idx" class="rq-item">
          <div style="width:120px;"><input v-model="it.item_date" type="date" class="rq-input w-100" /></div>
          <div class="flex-fill"><input v-model="it.description" class="rq-input w-100" placeholder="e.g. Bulls transport, lunch, traffic cess" /></div>
          <div style="width:140px;"><input v-model.number="it.amount_kes" type="number" class="rq-input w-100" style="text-align:right;" /></div>
          <div style="width:32px;"><button class="btn btn-sm btn-outline-danger" @click="form.items.splice(idx,1)"><i class="mdi mdi-close"></i></button></div>
        </div>
        <div class="rq-total">
          <span>Total</span>
          <span><strong>KES {{ Number(totalKes).toLocaleString() }}</strong></span>
        </div>
      </div>

      <div class="mb-3 mt-3"><label class="rq-label">Notes</label><textarea v-model="form.notes" class="rq-input w-100" rows="2"></textarea></div>

      <button class="btn btn-warning w-100" @click="save" :disabled="!canSave || saving">
        <span v-if="saving"><span class="spinner-border spinner-border-sm me-1"></span>Saving...</span>
        <span v-else><i class="mdi mdi-content-save me-1"></i>{{ form.id ? 'Save changes' : 'Create requisition' }}</span>
      </button>
      <button class="btn btn-sm btn-link text-muted w-100 mt-1" @click="showForm=false">Cancel</button>
    </div>
  </div>
</div>
</template>

<style>
:root{--fm-h:#F5F0E8;--fm-s:#6B6356;--fm-m:#A09888;--fm-bg1:#141414;--fm-bg2:#0F0F0F;--fm-bg3:#1E1E1E;--fm-br:#1E1E1E}
html[data-theme="light"]{--fm-h:#1A1A1A;--fm-s:#777;--fm-m:#555;--fm-bg1:#FFFFFF;--fm-bg2:#F7F5F2;--fm-bg3:#F0EBE4;--fm-br:#E8E2DA}
html[data-theme="light"] .rq-root{background:#F7F5F2!important;color:#1A1A1A!important}
html[data-theme="light"] .rq-topbar{background:rgba(255,255,255,.95)!important;border-bottom-color:#E8E2DA!important}
html[data-theme="light"] .rq-card,html[data-theme="light"] .rq-modal{background:#FFFFFF!important;border-color:#E8E2DA!important}
html[data-theme="light"] .rq-input{background:#F7F5F2!important;border-color:#E0D8D0!important;color:#1A1A1A!important}
</style>

<style scoped>
.rq-root{background:var(--fm-bg2,#0A0A0A);min-height:100vh;color:var(--fm-h,#F5F0E8)}
.rq-topbar{position:sticky;top:0;z-index:100;padding:12px 0;background:var(--fm-bg1,#141414);backdrop-filter:blur(10px);border-bottom:1px solid var(--fm-br,#1E1E1E)}
.rq-container{padding-top:80px;padding-bottom:60px;max-width:880px}
.rq-card{background:var(--fm-bg1,#141414);border:1px solid var(--fm-br,#1E1E1E);border-radius:12px;padding:14px}
.rq-ref{font-family:monospace;color:#BFA164;font-weight:700;font-size:13px;background:rgba(191,161,100,.1);padding:3px 8px;border-radius:6px}
.rq-status{font-size:10px;font-weight:700;padding:3px 10px;border-radius:20px;text-transform:uppercase;letter-spacing:.4px}
.rq-status.st-draft{background:rgba(160,152,136,.16);color:#A09888}
.rq-status.st-submitted{background:rgba(102,178,255,.16);color:#66B2FF}
.rq-status.st-approved{background:rgba(80,200,120,.16);color:#50C878}
.rq-status.st-rejected{background:rgba(255,107,107,.16);color:#FF6B6B}
.rq-status.st-paid{background:rgba(191,161,100,.16);color:#BFA164}
.rq-label{display:block;font-size:11px;color:var(--fm-s);text-transform:uppercase;letter-spacing:.3px;margin-bottom:4px;font-weight:600}
.rq-input{background:var(--fm-bg2,#0F0F0F);border:1px solid var(--fm-br,#2A2520);border-radius:8px;padding:8px 10px;color:var(--fm-h,#F5F0E8);font-size:13px}
.rq-input:focus{outline:none;border-color:#BFA164}
.rq-empty{color:var(--fm-s,#6B6356);font-size:12px;padding:14px;text-align:center;border:1px dashed var(--fm-br,#2A2520);border-radius:8px}
.rq-items{display:flex;flex-direction:column;gap:6px}
.rq-item{display:flex;gap:8px;align-items:center}
.rq-item-head{font-size:11px;text-transform:uppercase;letter-spacing:.5px;color:var(--fm-s,#6B6356);padding:0 4px}
.rq-total{display:flex;justify-content:space-between;align-items:center;padding:10px 14px;background:rgba(191,161,100,.1);border:1px solid rgba(191,161,100,.3);border-radius:8px;margin-top:6px;font-size:14px;color:var(--fm-h,#F5F0E8)}
.rq-overlay{position:fixed;inset:0;background:rgba(0,0,0,.6);display:flex;align-items:flex-start;justify-content:center;padding:30px 16px;z-index:2000;overflow-y:auto}
.rq-modal{background:var(--fm-bg1,#141414);border:1px solid var(--fm-br,#1E1E1E);border-radius:14px;padding:20px;max-width:780px;width:100%}

/* ===== MOBILE — feels-like-an-app ===== */
@media (max-width: 768px) {
  .rq-container { padding-top: 60px !important; padding-bottom: calc(80px + env(safe-area-inset-bottom, 0px)) !important; padding-left: 12px !important; padding-right: 12px !important; }
  .rq-card { padding: 12px !important; border-radius: 10px !important; }
  .rq-overlay { padding: 14px; align-items: flex-end; }
  .rq-modal { padding: 14px; border-radius: 14px 14px 0 0; max-height: 90vh; overflow-y: auto; }
  .rq-total { padding: 8px 10px; font-size: 13px; }
}
</style>

<script>
/* eslint-disable */
import { executeJson, flocker } from "@/api";
export default {
  name: "Requisitions",
  data(){return{
    darkMode:(document.documentElement.getAttribute('data-theme')||localStorage.getItem('flockr_theme')||'dark')!=='light',
    themeObserver:null,
    loading:true, saving:false,
    farm:{}, reqs:[], canApprove:false,
    showForm:false,
    form:{ id:0, projectCode:'', activity:'', requisitionDate:new Date().toISOString().slice(0,10), notes:'', items:[] }
  }},
  computed:{
    themePageStyle(){ return this.darkMode ? 'background:#0A0A0A;min-height:100vh;color:#F5F0E8;' : 'background:#F7F5F2;min-height:100vh;color:#1A1A1A;'; },
    farmId(){ return this.$route.params.farmId; },
    totalKes(){ return this.form.items.reduce(function(sum, it){ return sum + (Number(it.amount_kes)||0); }, 0); },
    canSave(){ return this.form.activity && this.form.requisitionDate && this.form.items.length > 0; }
  },
  mounted(){
    this._applyThemeOnce();var self=this;
    this.themeObserver=new MutationObserver(function(){try{self._applyThemeOnce();}catch(e){}});
    this.themeObserver.observe(document.documentElement,{attributes:true,attributeFilter:['data-theme']});
    if(!sessionStorage.getItem('userId')){this.$router.push('/login');return}
    this.loadAll();
  },
  beforeUnmount(){ if(this.themeObserver){this.themeObserver.disconnect()} },
  methods:{
    _applyThemeOnce(){var current=document.documentElement.getAttribute('data-theme');var desired=(localStorage.getItem('flockr_theme')||current||'dark');if(current!==desired)document.documentElement.setAttribute('data-theme',desired);this.darkMode=desired!=='light';},
    fD(d){ if(!d)return''; try{ return new Date(d).toLocaleDateString(undefined,{day:'2-digit',month:'short',year:'numeric'}) }catch(e){return d} },
    statusLabel(s){ return ({draft:'Draft',submitted:'Submitted',approved:'Approved',rejected:'Rejected',paid:'Paid'})[s] || s; },
    async loadAll(){
      this.loading = true;
      try {
        var f = await executeJson({ function:'getFarmDetail', farmId:this.farmId }, flocker);
        if (f.data && f.data.success) {
          this.farm = (f.data.data && f.data.data.farm) || {};
          var uid = sessionStorage.getItem('userId') || '';
          // owner or manager-role member can approve
          this.canApprove = (String(this.farm.owner_id) === String(uid));
        }
        var r = await executeJson({ function:'listRequisitions', farmId:this.farmId }, flocker);
        if (r.data && r.data.success) this.reqs = (r.data.data && r.data.data.requisitions) || [];
      } catch(e){ console.error(e); }
      this.loading = false;
    },
    openCreate(){
      this.form = { id:0, projectCode:'', activity:'', requisitionDate:new Date().toISOString().slice(0,10), notes:'', items:[{ item_date:new Date().toISOString().slice(0,10), description:'', amount_kes:null }] };
      this.showForm = true;
    },
    async openEdit(r){
      try {
        var rr = await executeJson({ function:'getRequisition', requisitionId:r.id }, flocker);
        if (rr.data && rr.data.success) {
          var x = rr.data.data.requisition;
          this.form = {
            id: x.id, projectCode: x.project_code || '', activity: x.activity || '',
            requisitionDate: x.requisition_date || new Date().toISOString().slice(0,10),
            notes: x.notes || '',
            items: (x.items || []).map(function(it){ return { item_date: it.item_date, description: it.description, amount_kes: Number(it.amount_kes) }; })
          };
          this.showForm = true;
        }
      } catch(e){ alert('Could not load.') }
    },
    addItem(){ this.form.items.push({ item_date: this.form.requisitionDate, description:'', amount_kes: null }); },
    async save(){
      if (!this.canSave) return;
      this.saving = true;
      try {
        var p = {
          function: 'saveRequisition',
          farmId: this.farmId,
          userId: sessionStorage.getItem('userId'),
          projectCode: this.form.projectCode || '',
          activity: this.form.activity,
          requisitionDate: this.form.requisitionDate,
          notes: this.form.notes || '',
          items: JSON.stringify(this.form.items.filter(function(it){ return it.description && it.amount_kes; }))
        };
        if (this.form.id) p.requisitionId = this.form.id;
        var r = await executeJson(p, flocker);
        if (r.data && r.data.success) { this.showForm = false; await this.loadAll(); }
        else alert((r.data && r.data.message) || 'Failed to save');
      } catch(e){ alert('Network error'); }
      this.saving = false;
    },
    async submit(r){
      if (!confirm('Submit "' + r.document_ref + '" for approval?')) return;
      try {
        var rr = await executeJson({ function:'submitRequisition', requisitionId:r.id }, flocker);
        if (rr.data && rr.data.success) await this.loadAll();
      } catch(e){ alert('Network error') }
    },
    async decide(r, decision){
      var reason = '';
      if (decision === 'rejected') {
        var n = prompt('Rejection reason:');
        if (n === null) return;
        reason = n;
      } else if (!confirm('Mark "' + r.document_ref + '" as ' + decision + '?')) return;
      try {
        var rr = await executeJson({ function:'approveRequisition', requisitionId:r.id, userId: sessionStorage.getItem('userId'), decision: decision, reason: reason }, flocker);
        if (rr.data && rr.data.success) await this.loadAll();
        else alert((rr.data && rr.data.message) || 'Failed');
      } catch(e){ alert('Network error') }
    },
    openPrint(r){
      var route = this.$router.resolve({ path: '/requisition/' + r.id + '/print' });
      window.open(route.href, '_blank');
    }
  }
};
</script>
